import React from 'react'

import { goToPost } from 'state/actions/posts'
import Link from 'redux-first-router-link'
import ScaledImage from 'components/ScaledImage'
import Badge from 'components/Badge'
import RelativeTime from 'components/RelativeTime'
import ReadTime from 'components/ReadTime'
import Title from 'components/Title'
import styles from './Activity.css'

const ArticleActivitySummary = ({ article, users }) => {
  let author = article.author._id ? article.author : users[article.author]
  return (
    <Link
      to={goToPost({
        _id: article._id,
        group: article.group,
        name: article.name,
        username: author && author.username
      })}
      className={styles.article}
    >
      <ScaledImage
        className={styles.image}
        uuid={article.image?.uuid}
        w={80}
        h={60}
        crop={true}
      />
      <div className={styles.description}>
        <Title value={article.title} language={article.language} />
        <Badge user={author} linkToProfile={false}>
          <span className={styles.meta}>
            <RelativeTime value={article.modified} /> &middot;{' '}
            <ReadTime value={article.readTime} />
          </span>
        </Badge>
      </div>
    </Link>
  )
}

export default ArticleActivitySummary
